import { FirebaseApp } from "firebase/app";
import { User, getAuth, onAuthStateChanged } from "firebase/auth";
import { useEffect, useState } from "react";
import { Login } from "./login";
import { Releases } from "./releases";
import logo from '../assets/logo-logomark.png';
import { Upcoming } from "./upcoming";

// Firebase Auth user plus admin custom claim.
export interface ExtendedUser extends User {
  isAdmin?: boolean;
}

function App({ app }: { app: FirebaseApp }) {
  // 3 states:
  // User (logged in)
  // null (no user)
  // undefined (hasn't finished checking if there is a user)
  const [user, setUser] = useState<ExtendedUser | undefined | null>();

  useEffect(() => {
    onAuthStateChanged(getAuth(app), (user) => {
      if (!user) {
        setUser(user);
      } else {
        user.getIdTokenResult().then((result) => {
          setUser({ ...user, isAdmin: !!result.claims.admin });
        });
      }
    });
  }, [app]);

  return (
    <div>
      <header>
        <div className="title"><img src={logo} height="24px" alt="Firebase logo"/>Firebase JS Release Tracker</div>
        <Login auth={getAuth(app)} user={user} />
      </header>
      <Upcoming />
      <Releases app={app} user={user} />
    </div>
  );
}

export default App;
